import React from 'react';

const EvidenceInfoSection = () => {
  return (
    <section className="bg-[#db0058] py-8 sm:py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Three column content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          {/* Left column */}
          <div className="text-white">
            <p className="text-sm sm:text-base leading-relaxed">
              With people at the heart of everything we do — whether that's our customers, their customers, or our own employees — we're proud to be able to share stories of some of the tangible outcomes we've delivered over the years with consumer data.
            </p>
          </div>
          
          {/* Right column */}
          <div className="text-white">
            <p className="text-sm sm:text-base leading-relaxed">
              Take a look at the selection of case studies below to see how we've helped our customers use consumer data intelligently. You'll see how we've helped countless businesses to gain valuable insight from their existing data, optimise customer acquisition and retention, and more.
            </p>
          </div>
        </div>
        
        {/* Bottom tagline */}
        <div className="text-left mt-8 sm:mt-12">
          <h3 className="text-white text-xl sm:text-2xl md:text-3xl font-bold">
            Data provider? Full-service agency? Growth provider?<br />
            How about all of the above.
          </h3>
        </div>
      </div>
    </section>
  );
};

export default EvidenceInfoSection;